import React, { useState, useEffect } from "react"
import {
	Button,
	TextField,
	IconButton,
	Grid,
	Paper,
	Typography,
	Collapse,
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Modal,
	Box,
} from "@mui/material"
import { Add, ExpandMore, ExpandLess } from "@mui/icons-material"
import {
	adminGetNotificationTemplates,
	adminSaveNotificationTemplates,
	adminGetWhatsAppTemplates,
} from "../util/firebase" // adjust the import path as necessary
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import PreviewIcon from "@mui/icons-material/Preview"

const roles = ["NEWUSER", "BUYER", "USER", "SELLER", "ALLBIDDERS", "FAVORITES", "ASKER", "ADMIN"]

const Type = ({
	type,
	handleExpandToggle,
	expanded,
	data,
	handleDelete,
	handleExpandToggleRole,
	expandedRole,
	handleInputChange,
	handleAddChannel,
	handleAddRole,
	templatesList,
}) => {
	const [addRole, setAddRole] = useState("")
	const [templateModalOpen, setTemplateModalOpen] = useState(false)
	const [modalText, setModalText] = useState(null)
	const style = {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: 400,
		backgroundColor: "white",
		border: "2px solid #000",
		boxShadow: 24,
		p: 4,
	}

	return (
		<Grid item xs={12} key={type} style={{ marginBottom: "10px" }}>
			<Modal
				open={templateModalOpen}
				onClose={() => setTemplateModalOpen(false)}
				/* sx={{ "& .MuiBackdrop-root": { backgroundColor: "transparent" } }} */
			>
				<Box style={style}>
					<Typography
						sx={{ ml: 2, flex: 1, mt: 2 }}
						variant="h7"
						component="div"
						dangerouslySetInnerHTML={{
							__html: modalText,
						}}
					/>
				</Box>
			</Modal>
			<Paper style={{ padding: "10px" /* backgroundColor: "#f5f5f5" */ }}>
				<Grid container justifyContent="space-between" alignItems="center">
					<Typography variant="h6">{type}</Typography>
					<IconButton onClick={() => handleExpandToggle(type)}>
						{expanded[type] ? <ExpandLess /> : <ExpandMore />}
					</IconButton>
				</Grid>
				<Collapse in={expanded[type]}>
					{expanded[type] && (
						<>
							{Object.keys(data[type]).map((role) => (
								<Paper
									style={{ marginTop: "20px", marginBottom: "20px", padding: "10px", backgroundColor: "#E8EFFF" }}
									key={role}
								>
									<Grid container spacing={2} pl={"60px"}>
										<Grid item xs={12} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
											<div>
												<IconButton onClick={(e) => handleDelete(type, role)}>
													<DeleteForeverIcon />
												</IconButton>
												<Typography variant="h7">{role}</Typography>
											</div>
											<IconButton onClick={() => handleExpandToggleRole(role)}>
												{expandedRole[role] ? <ExpandLess /> : <ExpandMore />}
											</IconButton>
										</Grid>
										<Grid item xs={12}>
											<Collapse in={expandedRole[role]}>
												{Object.keys(data[type][role]).map((channel) => (
													<Paper
														style={{
															marginTop: "20px",
															marginBottom: "20px",
															padding: "10px",
															/* backgroundColor: "#DDDDDD", */
															/* width: "100%", */
														}}
														key={channel}
													>
														<Grid container spacing={2} pl={"60px"}>
															<Grid item xs={12}>
																<IconButton onClick={(e) => handleDelete(type, role, channel)}>
																	<DeleteForeverIcon />
																</IconButton>
																<Typography variant="h7">{channel}</Typography>
																<Grid container spacing={2} pl={"60px"}>
																	<Grid item xs={12}>
																		{channel === "text" && (
																			<TextField
																				label={"text"}
																				value={data[type][role][channel]}
																				onChange={(e) => handleInputChange(type, role, channel, null, e.target.value)}
																				fullWidth
																				multiline
																			/>
																		)}
																		{channel === "email" && (
																			<>
																				<TextField
																					label={"subject"}
																					value={data[type][role][channel].subject}
																					onChange={(e) =>
																						handleInputChange(type, role, channel, "subject", e.target.value)
																					}
																					fullWidth
																					multiline
																				/>
																				<TextField
																					label={"body"}
																					value={data[type][role][channel].body}
																					onChange={(e) =>
																						handleInputChange(type, role, channel, "body", e.target.value)
																					}
																					fullWidth
																					multiline
																				/>
																			</>
																		)}
																		{channel === "whatsApp" && (
																			<>
																				<div style={{ direction: "ltr" }}>
																					<TextField
																						label={"params"}
																						value={data[type][role][channel].params.toString()}
																						onChange={(e) =>
																							handleInputChange(type, role, channel, "params", e.target.value)
																						}
																						fullWidth
																						multiline
																						/* sx={{ direction: "ltr", textAlign: "left" }} */
																					/>
																				</div>
																				{/* <TextField
																					label={"templateId"}
																					value={data[type][role][channel].templateId}
																					onChange={(e) =>
																						handleInputChange(type, role, channel, "templateId", e.target.value)
																					}
																					fullWidth
																					multiline
																				/> */}
																				<FormControl>
																					<InputLabel>Template Id</InputLabel>
																					<Select
																						/* sx={{ minWidth: "200px" }} */
																						value={data[type][role][channel].templateId}
																						label={"Template Id"}
																						onChange={(e) =>
																							handleInputChange(type, role, channel, "templateId", e.target.value)
																						}
																					>
																						{templatesList.map((template) => (
																							<MenuItem key={template.templateId} value={template.templateId}>
																								{template.templateId} - {template.templateName}
																							</MenuItem>
																						))}
																					</Select>
																					<IconButton
																						onClick={(e) => {
																							setModalText(
																								templatesList
																									.filter(
																										(e) =>
																											e.templateId.toString() ===
																											data[type][role][channel].templateId.toString()
																									)[0]
																									?.text.replaceAll("\r\n", "<br/>")
																							)
																							setTemplateModalOpen(true)
																						}}
																					>
																						<PreviewIcon />
																					</IconButton>
																				</FormControl>
																			</>
																		)}
																	</Grid>
																</Grid>
															</Grid>
														</Grid>
													</Paper>
												))}
												{Object.keys(data[type][role]).indexOf("text") === -1 && (
													<IconButton onClick={(e) => handleAddChannel(type, role, "text")}>
														<Add />
														Text
													</IconButton>
												)}
												{Object.keys(data[type][role]).indexOf("email") === -1 && (
													<IconButton onClick={(e) => handleAddChannel(type, role, "email")}>
														<Add />
														Email
													</IconButton>
												)}
												{Object.keys(data[type][role]).indexOf("whatsApp") === -1 && (
													<IconButton onClick={(e) => handleAddChannel(type, role, "whatsApp")}>
														<Add />
														WhatsApp
													</IconButton>
												)}
											</Collapse>
										</Grid>
									</Grid>
								</Paper>
							))}
							<FormControl>
								<InputLabel>Choose Role</InputLabel>
								<Select
									sx={{ minWidth: "200px" }}
									value={addRole}
									label={"Choose Role"}
									onChange={(e) => setAddRole(e.target.value)}
								>
									{roles
										.filter((e) => Object.keys(data[type]).indexOf(e) === -1)
										.map((role) => (
											<MenuItem key={role} value={role}>
												{role}
											</MenuItem>
										))}
								</Select>
							</FormControl>
							<IconButton onClick={(e) => handleAddRole(type, addRole)}>
								<Add />
							</IconButton>
						</>
					)}
				</Collapse>
			</Paper>
		</Grid>
	)
}

const NotificationTemplates = () => {
	const [data, setData] = useState({})
	const [expanded, setExpanded] = useState({})
	const [expandedRole, setExpandedRole] = useState({})
	const [addRole, setAddRole] = useState("")
	const [templatesList, setTemplatesList] = useState([])

	useEffect(() => {
		const _adminGetWhatsAppTemplates = async () => {
			const response = await adminGetWhatsAppTemplates()
			if (response.data.status === 0) {
				setTemplatesList(response.data.templates)
			}
		}
		_adminGetWhatsAppTemplates()
	}, [])

	useEffect(() => {
		const fetchData = async () => {
			const result = await adminGetNotificationTemplates()
			setData(result.data.notificationTemplates)
		}
		fetchData()
	}, [])

	const handleSave = async () => {
		console.log(data)
		await adminSaveNotificationTemplates(data)
	}

	const handleExpandToggle = (key) => {
		setExpanded((prev) => ({ ...prev, [key]: !prev[key] }))
	}

	const handleExpandToggleRole = (key) => {
		setExpandedRole((prev) => ({ ...prev, [key]: !prev[key] }))
	}

	const handleInputChange = (type, roles, channel, key, value) => {
		const updateData = { ...data }
		if (channel === "text") {
			updateData[type][roles][channel] = value
		} else if (channel === "whatsApp") {
			if (key === "templateId") {
				updateData[type][roles][channel][key] = value
			} else {
				updateData[type][roles][channel][key] = value.split(",")
			}
		} else if (channel === "email") {
			updateData[type][roles][channel][key] = value
		}
		setData(updateData)
	}

	const handleDelete = (type, role, channel) => {
		const updateData = { ...data }
		if (channel) {
			delete updateData[type][role][channel]
		} else if (role) {
			delete updateData[type][role]
		} else if (type) {
			delete updateData[type]
		}

		delete updateData[type][role][channel]
		setData(updateData)
	}

	const handleAddChannel = (type, role, channel) => {
		const updateData = { ...data }
		switch (channel) {
			case "text":
				updateData[type][role][channel] = ""
				break
			case "email":
				updateData[type][role][channel] = {
					subject: "",
					body: "",
				}
				break
			case "whatsApp":
				updateData[type][role][channel] = {
					params: "",
					templateId: "",
				}
				break
			default:
				break
		}
		setData(updateData)
	}

	const handleAddRole = (type, role) => {
		const updateData = { ...data }
		data[type][role] = {}
		setData(updateData)
		setAddRole("")
	}

	const renderFields = (data) => {
		return Object.keys(data).map((type) => {
			return (
				<Type
					key={type}
					type={type}
					handleExpandToggle={handleExpandToggle}
					expanded={expanded}
					data={data}
					handleDelete={handleDelete}
					handleExpandToggleRole={handleExpandToggleRole}
					expandedRole={expandedRole}
					handleInputChange={handleInputChange}
					handleAddChannel={handleAddChannel}
					addRole={addRole}
					setAddRole={setAddRole}
					handleAddRole={handleAddRole}
					templatesList={templatesList}
				/>
			)
		})
	}

	return (
		<div>
			<Typography variant="h4">Notification Templates</Typography>
			<Grid container spacing={2}>
				{renderFields(data)}
			</Grid>
			<Button variant="contained" color="primary" onClick={handleSave} style={{ marginTop: "20px" }}>
				Save
			</Button>
		</div>
	)
}

export default NotificationTemplates
